import { render, staticRenderFns } from "./DemoVideoAlert.vue?vue&type=template&id=be798f74&scoped=true&"
import script from "./DemoVideoAlert.vue?vue&type=script&lang=js&"
export * from "./DemoVideoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be798f74",
  null
  
)

export default component.exports